import { useState } from "react";
import { useDeleteQuery } from "../hooks";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import ResponsibilityAdd from "./ResponsibilityAdd";
import ResponsibilityEdit from "./ResponsibilityEdit";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";
import Avatar from "./Avatar";
import { useDataContext } from "../contexts";

export default function ResponsibilityCRUD() {
  const { responsibilities, getMemberUserById } = useDataContext();
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState(null);
  const [deleteModalId, setDeleteModalId] = useState(null);

  const deleteResponsibility = useDeleteQuery("responsibilities");

  function renderAvailableUsers(responsibility) {
    return (
      <div className="flex gap-2">
        {responsibility.availableTo
          .map((id) => getMemberUserById(id))
          .filter((user) => user)
          .map((user) => (
            <Avatar key={user.id} name={user.name} />
          ))}
      </div>
    );
  }

  return (
    <Panel left="Responsibilities">
      <Grid
        data={responsibilities}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto_auto]"
        renderTestId={(responsibility) =>
          `Responsibility ${responsibility.name}`
        }
        columns={[
          { header: "Name", key: "name" },
          {
            header: "Members",
            render: renderAvailableUsers,
          },
          { header: "Per week", key: "timesPerWeek" },
          {
            header: "Actions",
            render: (responsibility) => (
              <Actions>
                <EditButton
                  key="edit"
                  onClick={() => setEditModalId(responsibility.id)}
                />
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(responsibility.id)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Responsibility"
      >
        <ResponsibilityAdd callback={() => setAddModalOpen(false)} />
      </Modal>
      <Modal
        isOpen={editModalId !== null}
        onClose={() => setEditModalId(null)}
        heading="Edit Responsibility"
      >
        {editModalId && (
          <ResponsibilityEdit
            id={editModalId}
            callback={() => setEditModalId(null)}
          />
        )}
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Responsibility"
        message="Are you sure you want to delete this responsibility?"
        confirmLabel="Delete"
        onConfirm={() => {
          deleteResponsibility.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
